import {useDispatch, useSelector} from 'react-redux'
import {defaultRegion} from '../../../../_metronic/helpers'
import {
  useSendMessageMutation,
  useCalculateSummaryMessageMutation,
} from '../../../../services/cellcast.v3'
import {GetCurrentData} from '../../../Utils/_helpers/GetCurrentData'
import {startLoadingSend, stopLoadingSend} from '../../../Redux/FrontEnd/Loading/LoadingSendSlice'
import {StoreReviewData} from './BulkMessageSlice/BulkMessageSlice'
import {
  getDefaultRegion,
  getIsDefaultRegion,
} from '../accounts/Overview/OverviewSlice/UserDetailsSlice'

export function useNewMessage() {
  const dispatch = useDispatch()
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const currentRegion = useSelector(getDefaultRegion)

  const [sendMessage] = useSendMessageMutation()

  const [calculateSummaryMessage] = useCalculateSummaryMessageMutation()

  const sendCalculateSummary = async (data: any) => {
    dispatch(startLoadingSend('review'))
    const payload = {
      ...data,
      sender: data?.sender?.value,
      message_type: data.camp_type,
      to: {
        selectedType: data?.to?.selectedType,
        value: data?.to?.value === 'all' ? [data?.to?.value] : data?.to?.value,
      },
    }

    delete payload.camp_type

    const summary: any = await calculateSummaryMessage({
      action: 'calculate_summary',
      data: payload,
    }).unwrap()

    if (!summary?.is_error) {
      dispatch(
        StoreReviewData({
          totalContactCount: summary?.data?.total_contact ?? 0,
          draftDeductibleCredits: summary?.data?.deductible_credit ?? 0,
          messageLength: summary?.data?.message_length ?? 0,
          previews: summary?.data?.previews ?? [],
        })
      )
    }
    dispatch(stopLoadingSend())

    return summary
  }

  const sendFinalMessage = async (data: any, action: string = 'send_message') => {
    dispatch(startLoadingSend('review'))
    const toMessage = typeof data?.to === 'string' ? JSON.parse(data.to) : data?.to
    const payload = {
      ...data,
      message_type: data.camp_type,
      to: {
        selectedType: toMessage?.selectedType,
        value: toMessage?.value === 'all' ? [toMessage?.value] : toMessage?.value,
      },
    }

    const result: any = await sendMessage({
      action: action,
      data: payload,
    }).unwrap()

    dispatch(stopLoadingSend())

    return result
  }

  return {
    isDefaultRegion,
    sendCalculateSummary,
    sendFinalMessage,
    currentRegion,
  }
}
